import React from "react";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  // Modified styles to scale smoothly on narrow viewports
  const iconStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "clamp(40px, 8vw, 60px)",
    height: "clamp(40px, 8vw, 60px)",
    borderRadius: "50%",
    fontSize: "clamp(20px, 4vw, 26px)",
    color: "#fff",
    transition: "background-color 0.3s ease",
    marginRight: "10px",
  };

  const containerStyle = {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  };

  return (
    <div>
      <section className="py-0 pt-7 bg-1000">
        <div className="container px-3 px-sm-4">
          
          {/* Custom style overrides to optimize layouts on modern/older mobile form-factors */}
          <style>{`
            .footer-newsletter-row {
              display: flex !important;
              flex-wrap: nowrap !important;
              align-items: center !important;
              gap: 8px !important;
            }
            .footer-newsletter-row .col-auto {
              flex: unset !important;
            }
            .footer-newsletter-input-wrap {
              position: relative !important;
              flex-grow: 1 !important;
              max-width: 300px !important;
            }
            @media (max-width: 575.98px) {
              .footer-headline { font-size: 1.15rem !important; }
              .footer-subheadline { font-size: 1rem !important; }
              .footer-newsletter-row {
                width: 100% !important;
              }
              .footer-newsletter-input-wrap {
                max-width: 100% !important;
              }
            }
          `}</style>

          <div className="row g-4" style={{ justifyContent: "space-between" }}>
            <div className="col-6 col-sm-6 col-md-4 col-lg-3 col-xxl-2 mb-3">
              <h5 className="lh-lg fw-bold text-white footer-headline">COMPANY</h5>
              <ul className="list-unstyled mb-md-4 mb-lg-0">
                <li className="lh-lg">
                  <Link className="text-200 text-decoration-none" to="/about">
                    About Us
                  </Link>
                </li>
                <li className="lh-lg">
                  <Link className="text-200 text-decoration-none" to="/career">
                    Careers
                  </Link>
                </li>
                <li className="lh-lg">
                  <Link className="text-200 text-decoration-none" to="/blog">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
            
            <div className="col-6 col-sm-6 col-md-4 col-lg-3 col-xxl-2 mb-3">
              <h5 className="lh-lg fw-bold text-white footer-headline">LEGAL</h5>
              <ul className="list-unstyled mb-md-4 mb-lg-0">
                <li className="lh-lg">
                  <Link className="text-200 text-decoration-none" to="/terms">
                    Terms &amp; Conditions
                  </Link>
                </li>
                <li className="lh-lg">
                  <Link className="text-200 text-decoration-none" to="/refund">
                    Refund &amp; Cancellation
                  </Link>
                </li>
                <li className="lh-lg">
                  <Link className="text-200 text-decoration-none" to="/privacy">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            
            <div className="col-12 col-md-8 col-lg-6 col-xxl-4">
              <h5 className="lh-lg fw-bold text-500 footer-headline">FOLLOW US</h5>
              <ul style={containerStyle} className="mb-3">
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61578153307565" style={iconStyle} className="bg-primary">
                    <FaFacebook />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/frozenwala_official/?igsh=MTl1dnhkeGxpYjdmdQ%3D%3D#" style={iconStyle} className="bg-danger">
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a href="https://x.com/FrozenWala" style={iconStyle} className="bg-primary">
                    <FaTwitter />
                  </a>
                </li>
              </ul>
              <h3 className="text-500 my-4 footer-subheadline" style={{ fontSize: "clamp(1.1rem, 2.5vw, 1.5rem)" }}>
                Receive exclusive offers and <br />
                discounts in your mailbox
              </h3>
              
              {/* Refactored inline grid framework for perfect form fields consistency */}
              <div className="footer-newsletter-row mb-5">
                <div className="footer-newsletter-input-wrap">
                  <i className="fas fa-envelope input-box-icon text-500 ms-3" style={{ position: "absolute", top: "50%", transform: "translateY(-50%)", zIndex: 4 }}></i>
                  <input
                    className="form-control input-box bg-800 border-0"
                    type="email"
                    placeholder="Enter Email"
                    aria-label="email"
                    style={{ paddingLeft: "2.5rem", height: "45px" }}
                  />
                </div>
                <div className="col-auto" style={{backgroundColor:"#e41f26"}}>
                  <button className="btn" type="submit" style={{ height: "45px", whiteSpace: "nowrap" }}>
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <hr className="border border-800 my-4" />
          
          <div className="row flex-center pb-3 g-2">
            <div className="col-md-6 order-1 order-md-0">
              <p className="text-200 text-center text-md-start small mb-0">
                All rights Reserved &copy; Megasfrozen Goods Pvt Ltd, {currentYear}
              </p>
            </div>
            <div className="col-md-6 order-0 order-md-1">
              <p className="text-200 text-center text-md-end small mb-0 d-flex align-items-center justify-content-center justify-content-md-end flex-wrap">
                Made by&nbsp;&nbsp;
                <svg
                  className="bi bi-suit-heart-fill"
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  fill="#e41f26"
                  viewBox="0 0 16 16"
                >
                  <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"></path>
                </svg>
                &nbsp;&nbsp;
                <a
                  className="text-200 fw-bold text-decoration-none"
                  href="https://siancesoftware.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>
                    <a
                      className="text-200 fw-bold text-decoration-none"
                      href="https://indianrmg.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      INDIANRMG AI TECH PRIVATE LIMITED
                    </a>
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;